// extracted by mini-css-extract-plugin
module.exports = {"content":"CommentItem_content__2rpEa","text":"CommentItem_text__2g8AV","date":"CommentItem_date__o-_NN"};